import * as _ from 'lodash';
import {createSelector} from 'reselect';

export const invitedTenant = state => _.get(state.invite, 'tenant');
export const inviteErrorMessage = state => _.get(state.invite, 'error.errorMessage');
export const inviteErrorCode = state => _.get(state.invite, 'error.errorCode');
export const inviteHttpErrorCode = state => _.get(state.invite, 'error.httpStatusCode');
export const loading = state => _.get(state.invite, 'isLoading', false);

export const inviteErrorInfo = createSelector(
    inviteErrorMessage,
    inviteErrorCode,
    inviteHttpErrorCode,
    (errorMessage, errorCode, httpStatusCode) => {
        return {
            errorMessage,
            errorCode,
            httpStatusCode,
        };
    }
);